import { DOUBLE, QUADRUPLE, CENTUPLE } from "../../constants/numbers.consts.js";
import getScrollableParent from "./getScrollableParent.util.js";
export const scrollElementIntoViewUtil = ({ element, scrollTime = QUADRUPLE * CENTUPLE, }) => new Promise((resolve) => {
    if (!element) {
        console.warn("scrollElementIntoView: Element is null or undefined.");
        resolve();
        return;
    }
    const scrollableParent = getScrollableParent(element);
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const onScrollEnd = () => {
        resolve();
    };
    if (scrollableParent) {
        const parentRect = scrollableParent.getBoundingClientRect();
        const scrollOffset = rect.top - parentRect.top - parentRect.height / DOUBLE + rect.height / DOUBLE;
        scrollableParent.scrollBy({
            top: scrollOffset,
            behavior: "smooth",
        });
        setTimeout(onScrollEnd, scrollTime); // Approximate scroll time
    }
    else {
        console.warn("No scrollable parent found, using window scroll.");
        const centerOffset = rect.top + window.scrollY - windowHeight / DOUBLE + rect.height / DOUBLE;
        window.scrollTo({
            top: centerOffset,
            behavior: "smooth",
        });
        setTimeout(onScrollEnd, scrollTime); // Approximate scroll time
    }
});
export default scrollElementIntoViewUtil;
